export const RULE_NAME_FIELD = 'rule_name';
export const LIQUID_TYPE_VAR = 'liquid_type';
